const hostname = window.location.hostname;

const backendUrl =
  hostname === 'itp-ctc.hubruxelles.be'
    ? 'https://itp-ctc.hubruxelles.be'
    : hostname === 'stg-itp-ctc.hubruxelles.be'
      ? 'https://stg-itp-ctc.hubruxelles.be'
      : hostname === 'training-itp-ctc.hubruxelles.be'
        ? 'https://training-itp-ctc.hubruxelles.be'
        : hostname === 'wslhost'
          ? `http://wslhost:9950`
          : hostname === 'dckdmp8.res.hub.internal'
            ? `http://dckdmp8.res.hub.internal:9950`
            : `http://${hostname}:899`;

console.log('backendUrl : ', backendUrl);
// In development (localhost), use relative URL to leverage CRA proxy
// In production, use the full backend URL
const graphqlUri =
  hostname === 'localhost' ? '/graphql' : `${backendUrl}/graphql`;

// these will be included in the forms but hidden from the user. they're
// used for legacy reasons.
export const HIDDEN_ATTRIBUTES = [
  'icf_1_0_signed',
  'icf_1_1_signed',
  'icf_2_0_signed',
  'icf_3_0_signed',
  'icf_3_1_signed',
  'icf_4_0_signed',
  'icf_4_1_signed',
  'icf_4_2_signed',
];

// ICF amendments share the exact same workflow as the version they amend
// (mirrors moscato/patientdata/icf.py):
export const ICF_3_FAMILY = ['3.0', '3.1'];
export const ICF_4_FAMILY = ['4.0', '4.1', '5.0'];
// ICF versions that exist but are not offered yet (registration, re-consent, dashboard filters):
export const HIDDEN_ICF_VERSIONS = ['5.0'];
// ICF versions for which the META frozen sample is optional:
export const META_FROZEN_OPTIONAL = ['5.0'];

export const Settings = {
  MEDIA_URL: hostname === 'localhost' ? '/media/' : `${backendUrl}/media/`,
  ACCESS_TOKEN: 'aurora.accessToken',
  GRAPHQL_URI: graphqlUri,
  // LOGIN_URL: `${backendUrl}/accounts/google/login/`,
  HOME_PAGE: '/patients',
  BACKEND_URL: hostname === 'localhost' ? '' : backendUrl,
};
